<div class="smash-spinner" (click)="onClick($event)">
	<div class="sp-wave before" [ngStyle]="{'border-color': waveColor, 'border-radius': borderRadius}"></div>
	<div class="smash-spinner-content-wrapper">
		<div class="smash-spinner-content">
			<div class="smash-spinner-logo" 
				[ngStyle]="{'border-radius': borderRadius}"
				[appBackgroundImage]="url || fallbackUrlLogo" 
				(imageLoading)="displayLoadingSpinner()" 
				(readyToDisplayImage)="hideLoadingSpinner()">		
			</div>
		</div>
	</div>
	<div class="longpress" *ngIf="!isSafari" [ngClass]="{'animate-longpress' : longpress }">
		<div id="halfclip">
			<div class="halfcircle" [ngStyle]="{'border-radius': borderRadius}" id="clipped">
			</div>
		</div>
		<div class="halfcircle" [ngStyle]="{'border-radius': borderRadius}" id="fixed">
		</div>
	</div>
	<div class="sp-wave after" [ngStyle]="{'border-color': waveColor, 'border-radius': borderRadius}"></div>
</div>